import { Button } from '@/components/ui/button.tsx';
import { MessageSquareIcon } from 'lucide-react';
import { useState } from 'react';
import { AppDialog } from '@/components/app/app-dialog.tsx';
import { Textarea } from '@/components/ui/textarea.tsx';
import { isEmpty } from '@/lib/utils.ts';
import { useAuth } from '@/stores/auth.store.ts';
import { TUser } from '@/types/models.ts';
import { useSendMessageMutation } from '@/app/account/api/queries.ts';

type Props = {
  title: string;
  message: string;
  subject: string;
  btnText?: string;
};

function getMessage(user: TUser, message: string) {
  if (!user) return '';
  const lines = [`Hi, ${user.rep.full_name}`, message, `Thank you, ${user.full_name}`];
  return lines.join('\n\n');
}

export function AppAssistanceButton({ title, message: messageIn, subject, btnText = 'NEED ASSISTANCE?' }: Props) {
  const { user } = useAuth();
  const [showAssistance, setShowAssistance] = useState(false);
  const [message, setMessage] = useState(getMessage(user, messageIn));

  const sendMessage = useSendMessageMutation();
  const onSendMessage = () => {
    sendMessage.mutateAsync({ message, subject }).then(() => {
      setShowAssistance(false);
    });
  };
  return (
    <>
      <Button variant="outline" size="lg" onClick={() => setShowAssistance(true)}>
        <MessageSquareIcon /> {btnText}
      </Button>
      {showAssistance && (
        <AppDialog title={`Get Assistance With ${title}`} onClose={() => setShowAssistance(false)} size="lg">
          <div className="dialog-body p-4">
            <div className="flex flex-col gap-4">
              <p className="text-lg text-center">Ask your representative. Feel free to change the message below.</p>
              <Textarea value={message} className="h-40 text-base!" onChange={(e) => setMessage(e.target.value)} />
            </div>
          </div>
          <div className="dialog-footer">
            <Button disabled={isEmpty(message)} onClick={onSendMessage}>
              SEND
            </Button>
          </div>
        </AppDialog>
      )}
    </>
  );
}
